import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIAuth = (namespace: CreateNS) => {
    namespace('auth')(({ func, prop, deps }) => {
        prop('token', deps.getAuthToken, {
            setter: deps.setAuthToken,
        });
        prop('anonymousToken', deps.getAnonymousToken, {
            setter: deps.setAnonymousToken,
        });
        func('setAnonymousToken', deps.setAnonymousToken);
        func('refreshToken', deps.refreshExistingTokenAndUpdateProfile);
        func('setToken', deps.setAuthToken);
        func('unstable_getDecodedJWT', deps.getDecodedJWT);
        func(
            'unstable_getDecodedAnonymousToken',
            deps.getDecodedAnonymousToken,
        );
        func('getValidatedToken', deps.getValidatedToken);
        // TODO: make non-optional when this code will change:
        // https://github.com/getndazn/auth-tv-chapter/blob/master/src/environment.ts
        prop(
            'unstable_fetchPartnerAccessCode',
            () => deps.fetchPartnerAccessCode,
            null,
        );
        func('isVip', deps.isVip);
    });
};
